module.exports = __webpack_public_path__ + "img/bg-darkblue-og.78e9af18.png";